import DatePicker from 'apollo-react/components/DatePicker';
import React from 'react';

import { useTranslation } from '../custom-hooks/useTranslation';
import { getUITA } from '../utils/commonUtils';
import { DATE_FORMAT, getDatePickerConfig } from '../utils/dateUtils';
import { isMobileDevice } from '../utils/windowDimensionsUtils';

export const CustomDatePicker = ({
  id,
  label = '',
  className = {},
  storeValue,
  onChangeHandler = () => {},
  onBlurHandler = () => {},
  isRequired,
  error,
  isDisabled,
  inputValue,
  onInputChangeHandler = () => {},
}) => {
  const translateString = useTranslation();

  const { mask, dateFormat, dateValue } = getDatePickerConfig(storeValue, inputValue);

  return (
    <DatePicker
      placeholder={translateString(DATE_FORMAT)}
      label={label}
      className={className}
      dateFormat={dateFormat}
      onChange={onChangeHandler}
      required={isRequired}
      value={dateValue}
      inputValue={inputValue}
      onInputChange={onInputChangeHandler}
      error={error}
      disabled={isDisabled}
      mask={mask}
      maskPlaceholder="_"
      onBlur={onBlurHandler}
      inputProps={{ id }}
      PopperProps={{
        style: { zIndex: isMobileDevice ? 1200 : 1999 },
        disablePortal: false,
        'ui-ta': getUITA('datepicker-popup'),
        dir: 'ltr',
      }}
      TodayButtonProps={{
        'ui-ta': getUITA('today-button'),
      }}
      todayText={translateString('Today')}
    />
  );
};
